import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { MACSIMA_ART_TOOL_CONVERTER_TOKEN, MacsimaArtToolConverter } from './macsima-art-tool.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        macsimaArtToolFeature: {
          module: () => import('./macsima-art-tool.module').then((m) => m.MacsimaArtToolModule),
          cmsComponents: ['macsima_art_tool'],
        },
      }
    }),
    {
      provide: MACSIMA_ART_TOOL_CONVERTER_TOKEN,
      useExisting: MacsimaArtToolConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        macsima_art_tool: MACSIMA_ART_TOOL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class MacsimaArtToolFeatureModule {}
